export default "__VITE_ASSET__Cya9wf8p__"